import React from "react";
import clsx from "clsx";

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import MediaPlayButton from "components/MediaPlayButton";
import CodedPPS from "../CodedPPs";

import useStyles from "./styles";

export interface Props {
  raceHistoryItem: racehorse360.IRaceHistory;
}

const PastPerformancesItem = (props: Props) => {
  const { raceHistoryItem } = props;
  const classes = useStyles();

  const handleOpenVideo = (event: React.MouseEvent) => {
    return;
  };

  return (
    <TableRow key={raceHistoryItem.id}>
      <TableCell className={classes.ppTableCell}>
        <CodedPPS raceHistory={raceHistoryItem} />
      </TableCell>
      <TableCell className={clsx(classes.actions, classes.hidden)}>
        {/*TODO: video replay*/}
        <MediaPlayButton
          onOpenMedia={handleOpenVideo}
          isDisabled={!raceHistoryItem["replay"]}
        />
      </TableCell>
    </TableRow>
  );
};

export default PastPerformancesItem;
